module.exports = __webpack_public_path__ + "img/sad-dog.bb85698a.png";